/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationSharedCredentialsQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  clientApplicationId: Types.Scalars['UUID']['input'];
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ClientApplicationSharedCredentialsQuery = { __typename: 'Query', clientApplication?: { __typename: 'ClientApplicationType', id: string, credentials?: { __typename: 'ClientApplicationCredentialTypeConnection', edges: Array<{ __typename: 'ClientApplicationCredentialTypeEdge', node?: { __typename: 'ClientApplicationCredentialType', id: string, value: string, createdAt: string, updatedAt: string, sessions?: { __typename: 'ClientEmployeeSessionTypeConnection', edges: Array<{ __typename: 'ClientEmployeeSessionTypeEdge', node?: { __typename: 'ClientEmployeeSessionType', id: string, updatedAt: string, employee: { __typename: 'ResourceGroupEmployeeType', id: string, name: string, email: string } } | null } | null> } | null } | null } | null> } | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ClientApplicationSharedCredentialsDocument = new TypedDocumentString(`
    query ClientApplicationSharedCredentials($clientId: UUID!, $clientApplicationId: UUID!, $search: String) {
  clientApplication(clientId: $clientId, id: $clientApplicationId) {
    id
    credentials(first: 100, isShared: true, value_Icontains: $search) {
      edges {
        node {
          id
          value
          createdAt
          updatedAt
          sessions(first: 100) {
            edges {
              node {
                id
                employee {
                  id
                  name
                  email
                }
                updatedAt
              }
            }
          }
        }
      }
    }
  }
}
    `);

export const useClientApplicationSharedCredentialsQuery = <
      TData = ClientApplicationSharedCredentialsQuery,
      TError = unknown
    >(
      variables: ClientApplicationSharedCredentialsQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationSharedCredentialsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationSharedCredentialsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationSharedCredentialsQuery, TError, TData>(
      {
    queryKey: ['ClientApplicationSharedCredentials', variables],
    queryFn: fetcher<ClientApplicationSharedCredentialsQuery, ClientApplicationSharedCredentialsQueryVariables>(ClientApplicationSharedCredentialsDocument, variables),
    ...options
  }
    )};

useClientApplicationSharedCredentialsQuery.getKey = (variables: ClientApplicationSharedCredentialsQueryVariables) => ['ClientApplicationSharedCredentials', variables];

export const useInfiniteClientApplicationSharedCredentialsQuery = <
      TData = InfiniteData<ClientApplicationSharedCredentialsQuery>,
      TError = unknown
    >(
      variables: ClientApplicationSharedCredentialsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationSharedCredentialsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationSharedCredentialsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationSharedCredentialsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplicationSharedCredentials.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationSharedCredentialsQuery, ClientApplicationSharedCredentialsQueryVariables>(ClientApplicationSharedCredentialsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationSharedCredentialsQuery.getKey = (variables: ClientApplicationSharedCredentialsQueryVariables) => ['ClientApplicationSharedCredentials.infinite', variables];


useClientApplicationSharedCredentialsQuery.fetcher = (variables: ClientApplicationSharedCredentialsQueryVariables) => fetcher<ClientApplicationSharedCredentialsQuery, ClientApplicationSharedCredentialsQueryVariables>(ClientApplicationSharedCredentialsDocument, variables);
